<template>
  <div id="app">
    <DragCard
      :list="list"
      :col="4"
      :itemWidth="150"
      :itemHeight="150">
      <template slot-scope="data" slot="head">
        <div>{{data.item.head}}</div>
      </template>
      <template slot-scope="data" slot="content">
        <div>{{data.item.name}}</div>
      </template>
    </DragCard>
  </div>
</template>

<script>
  import DragCard from './components/DragCard.vue'

  export default {
    name: 'app',
    components: {
      DragCard
    },
    data() {
      return {
        list: [
          {head: '标题0', name: "演示卡片0"},
          {head: '标题1', name: "演示卡片1"},
          {head: '标题2', name: "演示卡片2"},
          {head: '标题3', name: "演示卡片3"},
          {head: '标题4', name: "演示卡片4"},
          {head: '标题5', name: "演示卡片5"},
          {head: '标题6', name: "演示卡片6"},
          {head: '标题7', name: "演示卡片7"},
          {head: '标题8', name: "演示卡片8"},
          {head: '标题9', name: "演示卡片9"},
        ],
      }
    }
  }
</script>

<style lang="scss" scoped="">
  #app {
    background: #ddd;
  }
</style>
